module.exports = __webpack_public_path__ + "img/bandcamp.f92545ab.png";